import { Link } from "react-router-dom";
import { Seo } from "../components/site/Seo";

export default function NotFound() {
  return (
    <section className="wrap flex min-h-[70vh] flex-col justify-center py-24" data-testid="not-found">
      <Seo title="Page not found" description="This page doesn't exist." />
      <p className="font-display text-[8rem] font-extrabold leading-none tracking-tighter text-flame sm:text-[12rem]">404</p>
      <h1 className="mt-4 font-display text-3xl font-bold text-ink sm:text-5xl">This page lost its momentum.</h1>
      <Link to="/" className="btn-primary mt-10 self-start">Back to home</Link>
    </section>
  );
}
